
import { FSharpRef, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { LabelId, LabelId__get_unwrap, StorageId_$reflection, CategoryMinimumQuantityId_$reflection, LabelId_$reflection } from "./Shared.js";
import { list_type, anonRecord_type, class_type, int32_type, record_type, option_type, bool_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { tryFind, ofList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { sortBy, choose, contains, exists, tryFind as tryFind_1, singleton, append, collect as collect_1, filter, empty, cons, map } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { comparePrimitives, safeHash, equals, compare } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { List_distinct } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { tryParse } from "../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";

export class Label extends Record {
    constructor(Id, Name, ColorHex, VisibleForUserRole, ParentLabelId) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.ColorHex = ColorHex;
        this.VisibleForUserRole = VisibleForUserRole;
        this.ParentLabelId = ParentLabelId;
    }
}

export function Label_$reflection() {
    return record_type("Shared.Category.Label", [], Label, () => [["Id", LabelId_$reflection()], ["Name", string_type], ["ColorHex", string_type], ["VisibleForUserRole", bool_type], ["ParentLabelId", option_type(LabelId_$reflection())]]);
}

export class CategoryMinimumQuantity extends Record {
    constructor(Id, CategoryId, StorageId, Quantity, CreatedAt, UpdatedAt) {
        super();
        this.Id = Id;
        this.CategoryId = CategoryId;
        this.StorageId = StorageId;
        this.Quantity = (Quantity | 0);
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
    }
}

export function CategoryMinimumQuantity_$reflection() {
    return record_type("Shared.Category.CategoryMinimumQuantity", [], CategoryMinimumQuantity, () => [["Id", CategoryMinimumQuantityId_$reflection()], ["CategoryId", LabelId_$reflection()], ["StorageId", StorageId_$reflection()], ["Quantity", int32_type], ["CreatedAt", class_type("System.DateTime")], ["UpdatedAt", class_type("System.DateTime")]]);
}

export class DTO_CategoryDetailsDto extends Record {
    constructor(Id, Name, ColorHex, VisibleForUserRole, ParentLabelId, MinimumQuantityStorages) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.ColorHex = ColorHex;
        this.VisibleForUserRole = VisibleForUserRole;
        this.ParentLabelId = ParentLabelId;
        this.MinimumQuantityStorages = MinimumQuantityStorages;
    }
}

export function DTO_CategoryDetailsDto_$reflection() {
    return record_type("Shared.Category.DTO.CategoryDetailsDto", [], DTO_CategoryDetailsDto, () => [["Id", LabelId_$reflection()], ["Name", string_type], ["ColorHex", string_type], ["VisibleForUserRole", bool_type], ["ParentLabelId", option_type(LabelId_$reflection())], ["MinimumQuantityStorages", list_type(anonRecord_type(["CategoryMinimumQuantityId", CategoryMinimumQuantityId_$reflection()], ["Quantity", int32_type], ["StorageId", StorageId_$reflection()], ["StorageName", string_type]))]]);
}

export class DTO_WriteCategoryDto extends Record {
    constructor(Name, ColorHex, VisibleForUserRole, ParentLabelId) {
        super();
        this.Name = Name;
        this.ColorHex = ColorHex;
        this.VisibleForUserRole = VisibleForUserRole;
        this.ParentLabelId = ParentLabelId;
    }
}

export function DTO_WriteCategoryDto_$reflection() {
    return record_type("Shared.Category.DTO.WriteCategoryDto", [], DTO_WriteCategoryDto, () => [["Name", string_type], ["ColorHex", string_type], ["VisibleForUserRole", bool_type], ["ParentLabelId", option_type(LabelId_$reflection())]]);
}

export class DTO_WriteCategoryMinimumQuantity extends Record {
    constructor(CategoryId, StorageId, Quantity) {
        super();
        this.CategoryId = CategoryId;
        this.StorageId = StorageId;
        this.Quantity = (Quantity | 0);
    }
}

export function DTO_WriteCategoryMinimumQuantity_$reflection() {
    return record_type("Shared.Category.DTO.WriteCategoryMinimumQuantity", [], DTO_WriteCategoryMinimumQuantity, () => [["CategoryId", LabelId_$reflection()], ["StorageId", StorageId_$reflection()], ["Quantity", int32_type]]);
}

export class DTO_UpdateNotificationStockDto extends Record {
    constructor(StorageId, NotificationQuantity) {
        super();
        this.StorageId = StorageId;
        this.NotificationQuantity = (NotificationQuantity | 0);
    }
}

export function DTO_UpdateNotificationStockDto_$reflection() {
    return record_type("Shared.Category.DTO.UpdateNotificationStockDto", [], DTO_UpdateNotificationStockDto, () => [["StorageId", string_type], ["NotificationQuantity", int32_type]]);
}

export function Hierarchy_getAncestors(allLabels, label) {
    const labelMap = ofList(map((l) => [l.Id, l], allLabels), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const collect = (acc_mut, currentId_mut) => {
        collect:
        while (true) {
            const acc = acc_mut, currentId = currentId_mut;
            const matchValue = tryFind(currentId, labelMap);
            if (matchValue == null) {
                return acc;
            }
            else {
                const l_1 = matchValue;
                const matchValue_1 = l_1.ParentLabelId;
                if (matchValue_1 == null) {
                    return cons(l_1, acc);
                }
                else {
                    acc_mut = cons(l_1, acc);
                    currentId_mut = matchValue_1;
                    continue collect;
                }
            }
            break;
        }
    };
    const matchValue_2 = label.ParentLabelId;
    if (matchValue_2 == null) {
        return empty();
    }
    else {
        return collect(empty(), matchValue_2);
    }
}

export function Hierarchy_getChildren(allLabels, labelId) {
    return filter((l) => equals(l.ParentLabelId, labelId), allLabels);
}

export function Hierarchy_getDescendants(allLabels, labelId) {
    const collect = (parentId) => collect_1((child) => cons(child, collect(child.Id)), filter((l) => equals(l.ParentLabelId, parentId), allLabels));
    return collect(labelId);
}

export function Hierarchy_getHierarchyChain(allLabels, label) {
    return append(Hierarchy_getAncestors(allLabels, label), singleton(label));
}

export function Hierarchy_getAllCategoryIdsInHierarchy(allLabels, labelIds) {
    return List_distinct(collect_1((labelId) => {
        const matchValue = tryFind_1((l) => equals(l.Id, labelId), allLabels);
        if (matchValue == null) {
            return singleton(labelId);
        }
        else {
            return map((_arg) => _arg.Id, Hierarchy_getHierarchyChain(allLabels, matchValue));
        }
    }, labelIds), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    });
}

export function Hierarchy_getDisplayName(allLabels, label) {
    return join(" > ", map((_arg) => _arg.Name, Hierarchy_getHierarchyChain(allLabels, label)));
}

export function Hierarchy_keepDeepestCategories(allLabels, labelIds) {
    const distinctIds = List_distinct(labelIds, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    });
    return filter((labelId) => {
        const descendantIds = map((_arg) => _arg.Id, Hierarchy_getDescendants(allLabels, labelId));
        return !exists((otherId) => contains(otherId, descendantIds, {
            Equals: equals,
            GetHashCode: (x_1) => (safeHash(x_1) | 0),
        }), distinctIds);
    }, distinctIds);
}

export function Hierarchy_filterToDeepestCategoryIds(allLabels, categoryIds) {
    return map(LabelId__get_unwrap, Hierarchy_keepDeepestCategories(allLabels, choose((id) => {
        let matchValue;
        let outArg = "00000000-0000-0000-0000-000000000000";
        matchValue = [tryParse(id, new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        if (matchValue[0]) {
            return new LabelId(matchValue[1]);
        }
        else {
            return undefined;
        }
    }, categoryIds)));
}

export function Hierarchy_buildTreeOrderedList(allLabels) {
    const build = (parentId, depth) => collect_1((l_2) => cons([l_2, depth], build(l_2.Id, depth + 1)), sortBy((l_1) => l_1.Name.toLocaleLowerCase(), filter((l) => equals(l.ParentLabelId, parentId), allLabels), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }));
    return build(undefined, 0);
}

